import React from "react";
import { DetailAndAllowcateForSkillDevelopmentContainer } from "../../../containers/SupportSystem/SupportForm/DetailAndAllowcateForSkillDevelopmentContainer";

export function DetailAndAllocateForSkillDevelopmentPage () {
    return(
        <DetailAndAllowcateForSkillDevelopmentContainer/>
    )
}